// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {

    makeResponsive("#ca27","h4",5);

});

 

// Responsive Text Function - Do Not Edit

function makeResponsive(elementId,textTheme,fontSize,fontColor,lineHeight,charSpacing,width) {

let style = "font-size:"+fontSize+"vw;color:"+fontColor+";line-height:"+lineHeight+";letter-spacing:"+charSpacing+"vw;width:"+width+"vw";

$w(elementId).html = "<"+textTheme+" style="+style+">"+$w(elementId).text+"</"+textTheme+">";

}